const { default: initialState } = require("./initialState");

const blogReducer = (state = initialState, action) => {
  return state;
};

export default blogReducer;
